<template>
  <div class="-mt-12">
    <dashboard-section v-if="invitedApplications.length">
      <template #title>
        <h2 class="text-xl mb-2 pr-6 mr-6 border-r">
          {{ singleStageGrading ? "Submitted" : "Invited" }} Applications
        </h2>
        <p class="pb-1">{{ invitedApplications.length }} Applications</p>
      </template>
      <ul class="-mt-2 list-reset flex flex-wrap -mx-4">
        <li
          v-for="application in invitedApplications"
          :key="application.uuid"
          class="w-full lg:w-1/3 lg:flex p-4"
        >
          <app-card status="invited" class="px-6 py-4">
            <div class="flex items-start">
              <div class="flex-1">
                <app-badge type="positive" icon="check">
                  {{ singleStageGrading ? "Submitted" : "Invited" }}
                </app-badge>
                <h2
                  class="text-xl mb-2 leading-tight"
                  v-html="applicationTitle(application)"
                />
              </div>
              <card-actions>
                <ul class="list-reset text-sm text-center">
                  <li class="p-2">
                    <a
                      class="block no-underline hover:text-primary-600 text-black"
                      target="_blank"
                      :href="
                        route('competitions.application.view', {
                          competition: state.competition.uuid,
                          application: application.uuid
                        })
                      "
                      >View</a
                    >
                  </li>
                  <!-- <li class="p-2 border-t border-grey-200">
                    <a
                      class="block no-underline hover:text-negative-800 text-negative-600 font-bold"
                      href="#"
                    >Delete</a>
                  </li> -->
                </ul>
              </card-actions>
            </div>
            <p class="mb-2 text-grey-700">
              {{ getApplicant(application.uuid, "company") | sentencecase }}
            </p>
            <p class="mb-2 text-sm text-grey-700">
              <icon
                icon="user"
                class="w-4 h-4 icons-primary align-middle mr-2"
              />
              {{ getApplicant(application.uuid, "name") }}
            </p>
          </app-card>
        </li>
      </ul>
    </dashboard-section>
    <dashboard-section v-if="rejectedApplications.length">
      <template #title>
        <h2 class="text-xl mb-2 pr-6 mr-6 border-r">
          Rejected Applications
        </h2>
        <p class="pb-1">{{ rejectedApplications.length }} Applications</p>
      </template>
      <ul class="-mt-2 list-reset flex flex-wrap -mx-4">
        <li
          v-for="application in rejectedApplications"
          :key="application.uuid"
          class="w-full lg:w-1/3 lg:flex p-4"
        >
          <app-card status="rejected" class="px-6 py-4">
            <div class="flex items-start">
              <div class="flex-1">
                <app-badge type="negative" icon="close">
                  Rejected
                </app-badge>
                <h2
                  class="text-xl mb-2 leading-tight"
                  v-html="applicationTitle(application)"
                />
              </div>
              <card-actions>
                <ul class="list-reset text-sm text-center">
                  <li class="p-2">
                    <a
                      class="block no-underline hover:text-primary-600 text-black"
                      target="_blank"
                      :href="
                        route('competitions.application.view', {
                          competition: state.competition.uuid,
                          application: application.uuid
                        })
                      "
                      >View</a
                    >
                  </li>
                  <!-- <li class="p-2 border-t border-grey-200">
                    <a
                      class="block no-underline hover:text-negative-800 text-negative-600 font-bold"
                      href="#"
                    >Delete</a>
                  </li> -->
                </ul>
              </card-actions>
            </div>
            <p class="mb-2 text-grey-700">
              {{ getApplicant(application.uuid, "company") | sentencecase }}
            </p>
            <p class="mb-2 text-sm text-grey-700">
              <icon
                icon="user"
                class="w-4 h-4 icons-primary align-middle mr-2"
              />
              {{ getApplicant(application.uuid, "name") }}
            </p>
          </app-card>
        </li>
      </ul>
    </dashboard-section>
    <dashboard-section v-if="submittedApplications.length">
      <template #title>
        <h2 class="text-xl mb-2 pr-6 mr-6 border-r">
          Submitted Applications
        </h2>
        <p class="pb-1">{{ submittedApplications.length }} Applications</p>
      </template>
      <ul class="-mt-2 list-reset flex flex-wrap -mx-4">
        <li
          v-for="application in submittedApplications"
          :key="application.uuid"
          class="w-full lg:w-1/3 lg:flex p-4"
        >
          <app-card
            :status="application.submitted_at ? 'complete' : 'draft'"
            class="px-6 py-4"
          >
            <div class="flex items-start">
              <div class="flex-1">
                <app-badge
                  :type="application.submitted_at ? 'positive' : 'neutral'"
                  :icon="application.submitted_at ? 'check' : 'time'"
                >
                  {{ application.submitted_at ? "Submitted" : "Draft" }}
                </app-badge>
                <h2
                  class="text-xl mb-2 leading-tight"
                  v-html="applicationTitle(application)"
                />
              </div>
              <card-actions>
                <ul class="list-reset text-sm text-center">
                  <li class="p-2">
                    <a
                      class="block no-underline hover:text-primary-600 text-black"
                      target="_blank"
                      :href="
                        route('competitions.application.view', {
                          competition: state.competition.uuid,
                          application: application.uuid
                        })
                      "
                      >View</a
                    >
                  </li>
                  <!-- <li class="p-2 border-t border-grey-200">
                    <a
                      class="block no-underline hover:text-negative-800 text-negative-600 font-bold"
                      href="#"
                    >Delete</a>
                  </li> -->
                </ul>
              </card-actions>
            </div>
            <p class="mb-2 text-grey-700">
              {{ getApplicant(application.uuid, "company") | sentencecase }}
            </p>
            <p class="mb-2 text-sm text-grey-700">
              <icon
                icon="user"
                class="w-4 h-4 icons-primary align-middle mr-2"
              />
              {{ getApplicant(application.uuid, "name") }}
            </p>
          </app-card>
        </li>
      </ul>
    </dashboard-section>
    <dashboard-section>
      <template #title>
        <h2 class="text-xl mb-2 pr-6 mr-6 border-r">
          {{ applicationOpen ? "Draft" : "Expired" }} Applications
        </h2>
        <p class="pb-1">{{ draftApplications.length }} Applications</p>
      </template>
      <ul class="-mt-2 list-reset flex flex-wrap -mx-4">
        <li
          v-for="application in draftApplications"
          :key="application.uuid"
          class="w-full lg:w-1/3 lg:flex p-4"
        >
          <app-card
            :status="
              application.submitted_at
                ? 'complete'
                : applicationOpen
                ? 'draft'
                : 'grey'
            "
            class="px-6 py-4 flex flex-col"
          >
            <div class="flex items-start">
              <div class="flex-1">
                <app-badge
                  :type="applicationOpen ? 'neutral' : 'grey'"
                  :icon="
                    application.application_progress_percentage === 100
                      ? 'important'
                      : 'time'
                  "
                >
                  {{
                    application.application_progress_percentage === 100
                      ? "Requires Submission"
                      : applicationOpen
                      ? "Draft"
                      : "Expired"
                  }}
                </app-badge>
                <h2
                  class="text-xl mb-2 leading-tight"
                  v-html="applicationTitle(application)"
                />
              </div>
              <card-actions>
                <ul class="list-reset text-sm text-center">
                  <li class="p-2">
                    <a
                      class="block no-underline hover:text-primary-600 text-black"
                      target="_blank"
                      :href="
                        route('competitions.application.view', {
                          competition: state.competition.uuid,
                          application: application.uuid
                        })
                      "
                      >View</a
                    >
                  </li>
                  <!-- <li class="p-2 border-t border-grey-200">
                    <a
                      class="block no-underline hover:text-negative-800 text-negative-600 font-bold"
                      href="#"
                    >Delete</a>
                  </li> -->
                </ul>
              </card-actions>
            </div>
            <div class="pb-4">
              <p class="mb-2 text-grey-700">
                {{ getApplicant(application.uuid, "company") | sentencecase }}
              </p>
              <p class="mb-2 text-sm text-grey-700">
                <icon
                  icon="user"
                  class="w-4 h-4 icons-primary align-middle mr-2"
                />
                {{ getApplicant(application.uuid, "name") }}
              </p>
            </div>
            <div
              class="-mx-6 -mb-4 px-6 mt-auto py-2 bg-grey-100 text-xs text-grey-500 border-t"
            >
              Progress:
              <b>{{ application.application_progress_percentage }}%</b>
            </div>
          </app-card>
        </li>
      </ul>
    </dashboard-section>
    <dashboard-section v-if="notStartedApplications.length">
      <template #title>
        <h2 class="text-xl mb-2 pr-6 mr-6 border-r">
          Applications Not Started
        </h2>
        <p class="pb-1">{{ notStartedApplications.length }} Applications</p>
      </template>
      <ul class="-mt-2 list-reset flex flex-wrap -mx-4">
        <li
          v-for="application in notStartedApplications"
          :key="application.uuid"
          class="w-full lg:w-1/3 lg:flex p-4"
        >
          <app-card status="grey" class="px-6 py-4">
            <div class="flex items-start">
              <div class="flex-1">
                <app-badge type="grey" icon="time">
                  Not Started
                </app-badge>
                <h2
                  class="text-xl mb-2 leading-tight"
                  v-html="applicationTitle(application)"
                />
              </div>
              <!-- <card-actions>
                <ul class="list-reset text-sm text-center">
                  <li class="p-2">
                    <a
                      class="block no-underline hover:text-primary-600 text-black"
                      target="_blank"
                      :href="route('competitions.application.view', { competition: state.competition.uuid, application: application.uuid})"
                    >View</a>
                  </li>
                </ul>
              </card-actions> -->
            </div>
            <p class="mb-2 text-grey-700">
              {{ getApplicant(application.uuid, "company") | sentencecase }}
            </p>
            <p class="mb-2 text-sm text-grey-700">
              <icon
                icon="user"
                class="w-4 h-4 icons-primary align-middle mr-2"
              />
              {{ getApplicant(application.uuid, "name") }}
            </p>
          </app-card>
        </li>
      </ul>
    </dashboard-section>
  </div>
</template>

<script>
import { competitionApplicationsMixin } from "../../mixins/competition";
export default {
  name: "CompetitionApplicastionsAll",
  mixins: [competitionApplicationsMixin],
  computed: {
    singleStageGrading() {
      return this.state.competition.single_stage_grading > 0;
    }
  }
};
</script>
